module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slider-testimonials"
  }, [_c('div', {
    staticClass: "slider-testimonials__container"
  }, [_c('div', {
    staticClass: "slider-testimonials__title"
  }, [_vm._v("Testimonials")]), _c('div', {
    staticClass: "slider-testimonials__subtitle"
  }, [_vm._v("What Our Patients Say About Us")]), _c('div', {
    directives: [{
      name: "slider-testimonials-directive",
      rawName: "v-slider-testimonials-directive"
    }],
    staticClass: "slider-testimonials__body"
  }, _vm._l((_vm.props), function(testimonial) {
    return _c('div', {
      staticClass: "slider-testimonials__testimonial"
    }, [_c('div', {
      staticClass: "slider-testimonials__stars"
    }, [_c('Icon', {
      attrs: {
        "name": "stars-01"
      }
    })], 1), _c('div', {
      staticClass: "slider-testimonials__content",
      domProps: {
        "innerHTML": _vm._s(testimonial.body)
      }
    }), _c('div', {
      staticClass: "slider-testimonials__author"
    }, [_vm._v(" - " + _vm._s(testimonial.author) + " -")])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-280bff9b","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/slider/slider-testimonials/slider-testimonials.pug
// module id = 636
// module chunks = 1